import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AlertCardComponent } from '@shared/components/alert-card/alert-card.component';
import { ReabrirNotaFiscalEntradaDialogData } from './reabrir-nota-fiscal-entrada-dialog-data';

/** Pede a justificativa da reabertura; a chamada à API fica com a listagem. */
@Component({
  selector: 'app-reabrir-nota-fiscal-entrada-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    AlertCardComponent,
  ],
  templateUrl: './reabrir-nota-fiscal-entrada-dialog.component.html',
  styleUrl: './reabrir-nota-fiscal-entrada-dialog.component.css',
})
export class ReabrirNotaFiscalEntradaDialogComponent {
  readonly justificativa = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required, Validators.minLength(10), Validators.maxLength(500)],
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReabrirNotaFiscalEntradaDialogData,
    private dialogRef: MatDialogRef<ReabrirNotaFiscalEntradaDialogComponent>
  ) {}

  cancelar(): void {
    this.dialogRef.close();
  }

  confirmar(): void {
    this.justificativa.markAsTouched();
    if (this.justificativa.invalid) return;
    this.dialogRef.close(this.justificativa.value.trim());
  }
}
